import { render, staticRenderFns } from "./GoodsText.vue?vue&type=template&id=b52bab88&scoped=true&"
import script from "./GoodsText.vue?vue&type=script&lang=js&"
export * from "./GoodsText.vue?vue&type=script&lang=js&"
import style0 from "./GoodsText.vue?vue&type=style&index=0&id=b52bab88&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52bab88",
  null
  
)

export default component.exports